import React from "react";
import CloseIcon from "@mui/icons-material/Close";

// ✅ Dark Glassmorphic Modal for Selecting Logic Gate Type
const GateSelectionModal = ({ onClose, onSelect }) => {
  const gates = [
    { name: "AND", color: "from-cyan-500 to-blue-600", desc: "Output ON only if ALL inputs are ON" },
    { name: "OR", color: "from-emerald-500 to-teal-600", desc: "Output ON if ANY input is ON" },
    { name: "XOR", color: "from-indigo-500 to-purple-600", desc: "Output ON if EXACTLY ONE input is ON" },
    { name: "NOT", color: "from-rose-500 to-pink-600", desc: "Inverts input signal (ON ➔ OFF)" },
    { name: "NAND", color: "from-amber-500 to-orange-600", desc: "Output OFF only if ALL inputs are ON" },
    { name: "NOR", color: "from-fuchsia-500 to-pink-600", desc: "Output ON only if ALL inputs are OFF" },
  ];

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-md flex justify-center items-center z-50">
      <div className="bg-slate-900 border border-cyan-500/40 p-6 rounded-2xl shadow-[0_0_30px_rgba(6,182,212,0.3)] text-white min-w-[480px] max-w-[540px]">
        <div className="flex justify-between items-center mb-4 pb-3 border-b border-slate-800">
          <h2 className="text-lg font-bold text-cyan-400">🧩 Select Logic Gate Type</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-rose-500 transition-colors">
            <CloseIcon />
          </button>
        </div>

        <div className="grid grid-cols-2 gap-3.5 my-2">
          {gates.map((g) => (
            <button
              key={g.name}
              onClick={() => onSelect(g.name)}
              className={`p-4 rounded-xl bg-gradient-to-r ${g.color} text-white font-bold text-left hover:scale-[1.03] transition-all shadow-lg hover:shadow-cyan-500/30 flex flex-col justify-between group cursor-pointer border border-white/10`}
            >
              <div className="text-base font-extrabold flex items-center justify-between">
                <span>{g.name} Gate</span>
                <span className="text-xs font-mono bg-black/30 px-2 py-0.5 rounded-md">[{g.name}]</span>
              </div>
              <p className="text-[11px] text-white/80 font-normal mt-1.5 leading-tight">{g.desc}</p>
            </button>
          ))}
        </div>

        <div className="flex justify-end mt-4 pt-3 border-t border-slate-800">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs font-bold rounded-xl"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default GateSelectionModal;
